/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum PaymentTypeApiModel {
  Cash = 'cash',

  BankCard = 'bank-card',

  BankCardExternal = 'bank-card-external',

  MobileApp = 'mobile-app',

  SpecialAccount = 'special-account'
}
